import React, { useState } from "react";
import "./Srchjobbanner.css";
import Comming from "../Commingsoon/Comming";

function Srchjobbanner() {
  
  return (
    <div className="banner-conatiner">
      <div className="banner-content">
        <div className="banner-txt">
          Post your job for millions of people to see and find the right
          candidate for your needs.
        </div>
        <div className="bannen-middle"></div>
        <button className="srch-job-btn" onClick={() => window.open("https://risohire.com/", "_blank")}>Post Job</button>
      </div>
      
    </div>
  );
}

export default Srchjobbanner;
